// import React, { useEffect, useState } from "react";
// import { getAdmins, updateAdminPermissions } from "../../../services/superAdminService"; // ✅ tumhare API service

// const AdminPermission = () => {
 
//   return (
//     <div >
     
//     </div>
//   );
// };

// export default AdminPermission;


import React, { useEffect, useState } from "react";
import { getAdmins, updateAdminPermissions } from "../../../services/superAdminService";
import { Table, Spinner, Alert, Form } from "react-bootstrap";

const AdminPermission = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [updatingId, setUpdatingId] = useState(null); // track which admin is being updated

  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = async () => {
    try {
      setLoading(true);
      const res = await getAdmins();
      setAdmins(res.data);
      setLoading(false);
    } catch (err) {
      setError(err.message || "Failed to fetch admins.");
      setLoading(false);
    }
  };

  const handlePermissionToggle = async (adminId, category, permissionType, currentValue) => {
    try {
      setUpdatingId(adminId);
      await updateAdminPermissions(adminId, category, permissionType, !currentValue);

      // Update UI locally after success
      setAdmins((prev) =>
        prev.map((admin) =>
          admin.id === adminId
            ? {
                ...admin,
                adminPermissions: {
                  ...admin.adminPermissions,
                  [category]: {
                    ...admin.adminPermissions[category],
                    [permissionType]: !currentValue,
                  },
                },
              }
            : admin
        )
      );
      setUpdatingId(null);
    } catch (err) {
      console.error("Error updating permission:", err);
      alert(err.response?.data?.message || "Failed to update permission");
      setUpdatingId(null);
    }
  };

  if (loading) return <Spinner animation="border" />;

  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <div style={{ padding: "20px" }}>
      <h3>Admin Permissions</h3>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Country</th>
            <th>State</th>
            <th>City</th>
            <th>Permissions</th>
          </tr>
        </thead>
        <tbody>
          {admins.map((admin) => (
            <tr key={admin.id}>
              <td>{admin.name}</td>
              <td>{admin.email}</td>
              <td>{admin.country?.name || "-"}</td>
              <td>{admin.state?.name || "-"}</td>
              <td>{admin.city?.name || "-"}</td>
              <td>
                {admin.adminPermissions &&
                  Object.entries(admin.adminPermissions).map(([category, perms]) => (
                    <div key={category} style={{ marginBottom: "10px" }}>
                      <strong>{category}</strong>
                      <div style={{ display: "flex", gap: "10px", marginTop: "5px" }}>
                        {Object.entries(perms).map(([permType, value]) => (
                          <Form.Check
                            key={permType}
                            type="switch"
                            id={`${admin.id}-${category}-${permType}`}
                            label={permType}
                            checked={value}
                            disabled={updatingId === admin.id}
                            onChange={() =>
                              handlePermissionToggle(admin.id, category, permType, value)
                            }
                          />
                        ))}
                      </div>
                    </div>
                  ))}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default AdminPermission;
